import { useFormikContext } from "formik";
import { ECheckedValue } from "library/types";
import { useEffect } from "react";

export function useHandleConsentAutoenrollmentDependency() {
  const { values, setFieldValue } = useFormikContext<FormData>();

  const consentsNeeded = values["consentsNeeded"] as ECheckedValue;
  const isAutoEnrollment = values["isAutoEnrollment"] as ECheckedValue;

  useEffect(() => {
    if (consentsNeeded === ECheckedValue.Yes) {
      setFieldValue("isAutoEnrollment", ECheckedValue.No);
      return;
    }

    if (isAutoEnrollment === ECheckedValue.Yes) {
      setFieldValue("consentsNeeded", ECheckedValue.No);
      return;
    }
  }, [consentsNeeded, isAutoEnrollment, setFieldValue]);
}
